module.exports = __webpack_public_path__ + "static/media/usmb.c6bdd1ab.png";